export default "__VITE_ASSET__4fd8063c__"